import request from "root/js/request";

export const postKeywordsPositionRunDelete = async ({ run_ids }) => {
  const response = await request({
    url: `/parsers/keywords_position/run_delete/`,
    method: "post",
    data: {
      run_ids,
    },
  });
  return response;
};
